import { findSbPosition } from 'components/app/_helpers/_app.helper';
import { StoryBoard } from 'services/storyboard.service';
import { SbPosition } from 'components/app/editor/_mediator/editor-controls.slice';
import { Clip, UNLINKED_ID } from 'components/app/editor/_mediator/editor.slice';
import { isLinked } from './editor-clips-linking.helper';

export const normalizeClipGroupId = (clip: Clip): Clip => ({
  ...clip,
  clipGroupId: isLinked(clip.clipGroupId) ? clip.clipGroupId : UNLINKED_ID,
});

export const isAutoHighlightClip = (clip: Clip): boolean => clip.isAutoHighlight === true || clip.highlightId != null;

/** Boundary nudge replaces the clip; detection row stays, story clip becomes manual (#495). */
export const decoupleAutoHighlightClip = (clip: Clip): Clip => ({
  ...clip,
  highlightId: undefined,
  isAutoHighlight: false,
  score: undefined,
});

export const prepareTimestampReplacementClip = (source: Clip, overrides: Partial<Clip> = {}): Clip => {
  const next = normalizeClipGroupId({ ...source, ...overrides });
  return isAutoHighlightClip(source) ? decoupleAutoHighlightClip(next) : next;
};

/** Anchor clip must be on a board; every edited clip must be findable before replace (#491). */
export const resolveTimestampReplacePosition = (
  editingClips: Clip[],
  isLeftNeighbor: boolean,
  storyBoard: StoryBoard
): SbPosition | null => {
  const anchor = editingClips[isLeftNeighbor ? 1 : 0];
  if (!anchor) return null;

  const position = findSbPosition(anchor.clipId, storyBoard);
  if (!position) return null;

  const allOnBoard = editingClips.every((clip) => findSbPosition(clip.clipId, storyBoard));
  return allOnBoard ? position : null;
};

export const storyboardDeleteDeltaSucceeded = (delta: Partial<StoryBoard>): boolean => Object.keys(delta).length > 0;
